var CryptoJS = require("crypto-js");


export const encryptData =  (data) => {
    return CryptoJS.AES.encrypt(data, process.env.REACT_APP_CRYPTO_KEY).toString();
}

export  const decryptedData = (data) => { return CryptoJS.AES.decrypt(data, process.env.REACT_APP_CRYPTO_KEY).toString(CryptoJS.enc.Utf8)}
